module.exports = __webpack_public_path__ + "static/media/183.d20dc120.png";